import React, { useState, useEffect, useContext } from 'react';
import { TRCCalendar } from '../../lib/atoms';
import { serverData } from '../../organisms/RFPComponent/context';
import { StyledEventDatesDiv } from './index.styles';
import { CALENDAR_DEFAULTS } from '../../constants';
import { ComponentProps } from '../../organisms/RFPComponent/RFPComponent.types';
import clsx from 'clsx';
import { iprops, datesInfo } from './index.types';
import { RadioButton } from '@marriott/mi-ui-library';

export const CalendarComponent: React.FC<iprops> = (props: iprops) => {
  const { jsonContent }: ComponentProps = useContext(serverData);
  const pageType = jsonContent?.['instanceType'];
  const labels = jsonContent?.['instance']?.labels ?? {};
  const eventDatesNode = { ...(jsonContent?.['instance']?.eventDates ?? {}) };
  const calendarConfig = {
    weekdaysLong: jsonContent?.['instance']?.eventDates.weekdaysLong ?? CALENDAR_DEFAULTS.weekdaysLong,
    weekdaysShort: jsonContent?.['instance']?.eventDates.weekdaysShort ?? CALENDAR_DEFAULTS.weekdaysShort,
    monthsLong: jsonContent?.['instance']?.eventDates.monthsLong ?? CALENDAR_DEFAULTS.monthsLong,
  };
  const eventDates = jsonContent?.['instance']?.eventDates?.fieldSet
    ? [...jsonContent['instance']['eventDates']['fieldSet']]
    : [];

  const [isFlexibleDates, setIsFlexibleDates] = useState('');

  const onClear = (flag: boolean) => {
    if (flag) {
      setIsFlexibleDates('');
      const flexibleDatesArr = Array.from(
        document.getElementsByClassName('flexibleDates') as HTMLCollectionOf<HTMLElement>
      )[0]?.children;
      for (let i = 0; i < flexibleDatesArr?.length; i++) {
        if (flexibleDatesArr[i]?.children[0]) {
          (flexibleDatesArr[i].children[0] as HTMLInputElement).checked = false;
        }
      }
    }
  };

  const handleSingleDay = (selectedDay?: React.ChangeEvent<HTMLInputElement>) => {
    props.onDataChange({
      key: eventDates[0]?.name,
      value: selectedDay,
    });
  };
  const handleMultipleDay = (selectedDay?: React.ChangeEvent<HTMLInputElement>, name?: string) => {
    props.onDataChange({
      key: name,
      value: selectedDay,
    });
  };

  useEffect(() => {
    onClear(props.onClear);
  }, [props.data, props.onClear]);

  return (
    <StyledEventDatesDiv data-component-name="m-trc-CalendarComponent" data-testid="trc-CalendarComponent">
      <p className="mb-md-5 pb-2 pb-md-3 pt-5 t-title-alt-s t-rc-italic">
        {props.index}.{jsonContent?.['instance']?.eventDates?.name}
      </p>
      {pageType === 'meetings' && (
        <div className="eventDates offset-xl-2 row d-flex flex-wrap pb-md-5">
          <div className="col-12 col-xl-6 col-md-8 mb-4 mb-md-5 mb-xl-0">
            <TRCCalendar
              type="single"
              placeholder={eventDatesNode?.dateFormat ?? 'Mon DD, YYYY'}
              labelName={`${eventDates[0]?.fieldName}`}
              mandatory={eventDates[0]?.mandatory}
              numberOfMonths={1}
              id={`${eventDates[0]?.name}`}
              isError={props?.data[0]?.isError}
              errorMessageClassName="t-font-s"
              errorMessage={eventDates[0]?.errorMessage}
              onClearFlag={props.onClear}
              labelClassName="rfp-calendar-label t-overline-alt-medium t-rc-text-transform-none"
              onSelect={handleSingleDay}
              disabled={props.submitted}
              calendarConfig={calendarConfig}
            />
          </div>

          <div className="col-12 col-xl-6 col-md-8 mb-4 mb-md-5 mb-xl-0">
            <TRCCalendar
              type="range"
              placeholder={eventDatesNode?.dateFormatRange ?? 'Mon DD, YYYY - Mon DD, YYYY'}
              labelName={`${eventDates[1]?.fieldName}`}
              mandatory={eventDates[0]?.mandatory}
              numberOfMonths={1}
              id={`${eventDates[1]?.name}`}
              isError={props?.data[1]?.isError}
              errorMessageClassName="t-font-s"
              errorMessage={eventDates[1]?.errorMessage}
              onClearFlag={props.onClear}
              labelClassName="rfp-calendar-label t-overline-alt-medium t-rc-text-transform-none"
              onSelect={(e?: React.ChangeEvent<HTMLInputElement>) => {
                handleMultipleDay(e, eventDates[1]?.name);
              }}
              disabled={props.submitted}
              calendarConfig={calendarConfig}
            />
          </div>
          <p className=" t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8 mt-xl-4 m-0 mb-xl-3 mb-4 mb-md-5 ">{`${
            eventDates[2]?.fieldName
          }${eventDates[2]?.mandatory ? '*' : ''}`}</p>
          <div className="flexibleDates d-flex col-12 col-xl-12 col-md-8">
            {eventDates[2]?.inputOptions?.map((item: { dependency: Array<string>; option: string }) => {
              return (
                <RadioButton
                  radiobuttonId={`${eventDates[2]?.name} ${item['option']}`}
                  radiobuttonName={eventDates[2]?.name + item['option']}
                  radiobuttonLabel={item['option']}
                  disabled={props.submitted}
                  className={clsx(
                    'm-radio-button-sm',
                    'pr-4',
                    `rfp-${eventDates[2]?.name}`,
                    props?.data[2]?.isError ? 'error' : ''
                  )}
                  labelClassName="t-font-m"
                  checked={item['option'] === props?.data[2]?.value}
                  onChange={(event: React.ChangeEvent<HTMLInputElement> | undefined) => {
                    event && setIsFlexibleDates(event.target.value);
                    if (event?.target.value === (labels?.noLabel ?? 'No')) {
                      props.onDataChange({
                        key: eventDates[3]?.name,
                        value: null,
                      });
                      props.onDataChange({
                        key: eventDates[4]?.name,
                        value: null,
                      });
                    }
                    props.onDataChange({
                      key: eventDates[2]?.name,
                      value: event?.target.value,
                    });
                  }}
                  onKeyDown={(event: React.KeyboardEvent) => {
                    if (event?.key === 'Enter' || event?.keyCode === 13) {
                      const target = event.target as HTMLInputElement;
                      event && setIsFlexibleDates(target?.value);
                      if (target?.value === (labels?.noLabel ?? 'No')) {
                        props.onDataChange({
                          key: eventDates[3]?.name,
                          value: null,
                        });
                        props.onDataChange({
                          key: eventDates[4]?.name,
                          value: null,
                        });
                      }
                      props.onDataChange({
                        key: eventDates[2]?.name,
                        value: target.value,
                      });
                    }
                  }}
                  value={item['option']}
                  setTabIndex={-1}
                />
              );
            })}
          </div>
          <div
            className={clsx(
              'error-text t-font-xs col-12 col-xl-12 col-md-8',
              props?.data[2]?.isError ? 'd-block' : 'd-none'
            )}
          >
            {eventDates[2]?.errorMessage}
          </div>
          {isFlexibleDates === (labels?.yesLabel ?? 'Yes') &&
            eventDates.map((item: datesInfo, index: number) => {
              if (index === 3 || index === 4) {
                return (
                  <div className={`col-12 col-xl-6 col-md-8 mt-xl-4 ${index === 3 ? 'my-4 my-md-5' : ''}`}>
                    <TRCCalendar
                      type="range"
                      placeholder={eventDatesNode?.dateFormatRange ?? 'Mon DD, YYYY - Mon DD, YYYY'}
                      key={item?.name}
                      labelName={`${item?.fieldName}`}
                      mandatory={item?.mandatory}
                      id={`${eventDates[index]?.name}`}
                      numberOfMonths={1}
                      isError={props?.data[index]?.isError}
                      errorMessageClassName="t-font-s"
                      errorMessage={item?.errorMessage}
                      onClearFlag={props.onClear}
                      flexibleDatesFlag={isFlexibleDates === (labels?.yesLabel ?? 'Yes') ? true : false}
                      labelClassName="rfp-calendar-label t-overline-alt-medium t-rc-text-transform-none"
                      onSelect={(e?: React.ChangeEvent<HTMLInputElement>) => {
                        handleMultipleDay(e, item?.name);
                      }}
                      disabled={props.submitted}
                      calendarConfig={calendarConfig}
                    />
                  </div>
                );
              }
            })}
        </div>
      )}
      {pageType === 'weddings' && (
        <div className="eventDates offset-xl-2 row d-flex flex-wrap pb-md-5">
          <div className="col-12 col-xl-6 col-md-8 mb-4 mb-md-5 mb-xl-0">
            <TRCCalendar
              type="range"
              placeholder={eventDatesNode?.dateFormatRange ?? 'Mon DD, YYYY - Mon DD, YYYY'}
              labelName={`${eventDates[0]?.fieldName}`}
              mandatory={eventDates[0]?.mandatory}
              numberOfMonths={1}
              id={`${eventDates[0]?.name}`}
              isError={props?.data[1]?.isError}
              errorMessageClassName="t-font-s"
              errorMessage={eventDates[0]?.errorMessage}
              onClearFlag={props.onClear}
              labelClassName="rfp-calendar-label t-overline-alt-medium t-rc-text-transform-none"
              onSelect={(e?: React.ChangeEvent<HTMLInputElement>) => {
                handleMultipleDay(e, eventDates[0]?.name);
              }}
              disabled={props.submitted}
              calendarConfig={calendarConfig}
            />
          </div>

          <p className="t-overline-alt-medium t-rc-text-transform-none col-12 col-xl-12 col-md-8 mt-xl-4 m-0 mb-xl-3 mb-4 mb-md-5">{`${
            eventDates[1]?.fieldName
          }
              ${eventDates[1]?.mandatory ? '*' : ''}`}</p>

          <div className="flexibleDates d-flex col-12 col-xl-12 col-md-8">
            {eventDates[1]?.inputOptions?.map((item: { dependency: Array<string>; option: string }) => {
              return (
                <RadioButton
                  radiobuttonId={`${eventDates[1]?.name} ${item['option']}`}
                  radiobuttonName={eventDates[1]?.name + item['option']}
                  radiobuttonLabel={item['option']}
                  disabled={props.submitted}
                  className={clsx(
                    'm-radio-button-sm',
                    'pr-4',
                    `rfp-${eventDates[1]?.name}`,
                    props?.data[2]?.isError ? 'error' : ''
                  )}
                  labelClassName="t-font-m"
                  checked={item['option'] === props?.data[2]?.value}
                  onChange={(event: React.ChangeEvent<HTMLInputElement> | undefined) => {
                    event && setIsFlexibleDates(event.target.value);
                    if (event?.target.value === (labels?.noLabel ?? 'No')) {
                      props.onDataChange({
                        key: eventDates[2]?.name,
                        value: null,
                      });
                      props.onDataChange({
                        key: eventDates[3]?.name,
                        value: null,
                      });
                    }
                    props.onDataChange({
                      key: eventDates[1]?.name,
                      value: event?.target.value,
                    });
                  }}
                  onKeyDown={(event: React.KeyboardEvent) => {
                    if (event?.key === 'Enter' || event?.keyCode === 13) {
                      const target = event?.target as HTMLInputElement;
                      event && setIsFlexibleDates(target?.value);
                      if (target.value === (labels?.noLabel ?? 'No')) {
                        props.onDataChange({
                          key: eventDates[2]?.name,
                          value: null,
                        });
                        props.onDataChange({
                          key: eventDates[3]?.name,
                          value: null,
                        });
                      }
                      props.onDataChange({
                        key: eventDates[1]?.name,
                        value: target?.value,
                      });
                    }
                  }}
                  value={item['option']}
                  setTabIndex={-1}
                />
              );
            })}
          </div>
          <div
            className={clsx(
              'error-text t-font-xs col-12 col-xl-12 col-md-8 mb-4 mb-md-5 mb-xl-0',
              props?.data[2]?.isError ? 'd-block' : 'd-none'
            )}
          >
            {eventDates[1]?.errorMessage}
          </div>

          {isFlexibleDates === (labels?.yesLabel ?? 'Yes') &&
            eventDates.map((item: datesInfo, index: number) => {
              if (index === 2 || index === 3) {
                return (
                  <div className={`col-12 col-xl-6 col-md-8 mt-xl-4 ${index === 2 ? 'my-4 my-md-5' : ''}`}>
                    <TRCCalendar
                      type="range"
                      placeholder={eventDatesNode?.dateFormatRange ?? 'Mon DD, YYYY - Mon DD, YYYY'}
                      labelName={`${item?.fieldName}`}
                      mandatory={item?.mandatory}
                      numberOfMonths={1}
                      id={`${eventDates[index]?.name}`}
                      isError={props?.data[index + 1]?.isError}
                      errorMessageClassName="t-font-s"
                      errorMessage={item?.errorMessage}
                      onClearFlag={props.onClear}
                      flexibleDatesFlag={isFlexibleDates === (labels?.yesLabel ?? 'Yes') ? true : false}
                      labelClassName="rfp-calendar-label t-overline-alt-medium t-rc-text-transform-none"
                      onSelect={(e?: React.ChangeEvent<HTMLInputElement>) => {
                        handleMultipleDay(e, item?.name);
                      }}
                      disabled={props.submitted}
                      calendarConfig={calendarConfig}
                    />
                  </div>
                );
              }
            })}
        </div>
      )}
    </StyledEventDatesDiv>
  );
};
